import React, { useState } from 'react';

/**
 * Chat-Liste in der Sidebar.
 * Pin/Rename/Delete inline mit Confirm.
 */
export default function ChatList({ chats, currentId, onSelect, onNew, onRename, onDelete, onPin }) {
  const [editingId, setEditingId] = useState(null);
  const [editingTitle, setEditingTitle] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(null);

  const startEdit = (c) => { setEditingId(c.id); setEditingTitle(c.title); };
  const commitEdit = () => {
    const original = chats.find(c => c.id === editingId)?.title;
    if (editingTitle.trim() && editingTitle !== original) {
      onRename(editingId, editingTitle.trim());
    }
    setEditingId(null);
    setEditingTitle('');
  };

  return (
    <div className="chat-list">
      <button className="chat-list-new" onClick={onNew} title="Neuer Chat">
        <span>＋</span> Neuer Chat
      </button>
      <div className="chat-list-items">
        {chats.length === 0 && (
          <div className="chat-list-empty">Noch keine Chats</div>
        )}
        {chats.map(c => (
          <div
            key={c.id}
            className={`chat-list-item ${currentId === c.id ? 'active' : ''} ${c.pinned ? 'pinned' : ''}`}
          >
            {editingId === c.id ? (
              <input
                className="chat-list-rename"
                value={editingTitle}
                onChange={e => setEditingTitle(e.target.value)}
                onBlur={commitEdit}
                onKeyDown={e => {
                  if (e.key === 'Enter') commitEdit();
                  if (e.key === 'Escape') { setEditingId(null); setEditingTitle(''); }
                }}
                autoFocus
              />
            ) : (
              <button
                className="chat-list-title"
                onClick={() => onSelect(c.id)}
                onDoubleClick={() => startEdit(c)}
                title={c.title}
              >
                {c.pinned ? '⚲ ' : ''}{c.title}
              </button>
            )}
            <div className="chat-list-actions">
              <button onClick={() => onPin(c.id, c.pinned)} title={c.pinned ? 'Unpin' : 'Pin'}>
                {c.pinned ? '✕' : '⚲'}
              </button>
              <button onClick={() => startEdit(c)} title="Umbenennen">✎</button>
              {confirmDelete === c.id ? (
                <>
                  <button className="confirm-yes" onClick={() => { onDelete(c.id); setConfirmDelete(null); }} title="Löschen bestätigen">✓</button>
                  <button onClick={() => setConfirmDelete(null)} title="Abbrechen">✗</button>
                </>
              ) : (
                <button onClick={() => setConfirmDelete(c.id)} title="Löschen">🗑</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
